import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2, MapPin } from 'lucide-react';
const buyers = [{
  name: 'Carlos M.',
  location: 'Ciudad de México, MX'
}, {
  name: 'Andrés R.',
  location: 'Bogotá, CO'
}, {
  name: 'Daniel T.',
  location: 'Madrid, ES'
}, {
  name: 'Mateo G.',
  location: 'Buenos Aires, AR'
}, {
  name: 'Santiago L.',
  location: 'Lima, PE'
}, {
  name: 'Diego F.',
  location: 'Santiago, CL'
}, {
  name: 'Javier P.',
  location: 'Caracas, VE'
}, {
  name: 'Alejandro V.',
  location: 'Quito, EC'
}, {
  name: 'Sebastián C.',
  location: 'Monterrey, MX'
}, {
  name: 'Nicolás H.',
  location: 'Medellín, CO'
}, {
  name: 'Fernando B.',
  location: 'Guadalajara, MX'
}, {
  name: 'Ricardo S.',
  location: 'Asunción, PY'
}, {
  name: 'Eduardo M.',
  location: 'San José, CR'
}, {
  name: 'Roberto N.',
  location: 'Panamá, PA'
}, {
  name: 'Miguel A.',
  location: 'Montevideo, UY'
}, {
  name: 'Luis O.',
  location: 'Barcelona, ES'
}, {
  name: 'José D.',
  location: 'La Paz, BO'
}, {
  name: 'Juan P.',
  location: 'Santo Domingo, DO'
}, {
  name: 'Antonio R.',
  location: 'Guatemala, GT'
}, {
  name: 'Francisco J.',
  location: 'Tegucigalpa, HN'
}, {
  name: 'Gabriel E.',
  location: 'Valencia, ES'
}, {
  name: 'Rafael T.',
  location: 'Cali, CO'
}, {
  name: 'Tomás Q.',
  location: 'Rosario, AR'
}, {
  name: 'Emilio K.',
  location: 'San Salvador, SV'
}, {
  name: 'Hugo I.',
  location: 'Managua, NI'
}, {
  name: 'Pablo Z.',
  location: 'Sevilla, ES'
}, {
  name: 'Martín U.',
  location: 'Córdoba, AR'
}, {
  name: 'Lucas Y.',
  location: 'Arequipa, PE'
}, {
  name: 'Adrián W.',
  location: 'Valparaíso, CL'
}, {
  name: 'Bruno X.',
  location: 'Mérida, MX'
}];
const minutesAgo = () => Math.floor(Math.random() * 8) + 1;
export function PurchaseNotification() {
  const [current, setCurrent] = useState<{
    name: string;
    location: string;
    minutes: number;
  } | null>(null);
  const [index, setIndex] = useState(0);
  useEffect(() => {
    // Show first notification after 5 seconds
    const initialTimeout = setTimeout(() => {
      const buyer = buyers[Math.floor(Math.random() * buyers.length)];
      setCurrent({
        ...buyer,
        minutes: minutesAgo()
      });
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  useEffect(() => {
    // Recurring notifications every 15 seconds
    const interval = setInterval(() => {
      const nextIndex = (index + Math.floor(Math.random() * 5) + 1) % buyers.length;
      setIndex(nextIndex);
      setCurrent({
        ...buyers[nextIndex],
        minutes: minutesAgo()
      });
    }, 15000);
    return () => clearInterval(interval);
  }, [index]);
  // Auto-hide after 5 seconds
  useEffect(() => {
    if (!current) return;
    const hideTimer = setTimeout(() => setCurrent(null), 5500);
    return () => clearTimeout(hideTimer);
  }, [current]);
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none max-w-[calc(100vw-2rem)] md:max-w-sm" data-id="element-223">
      <AnimatePresence mode="wait" data-id="element-224">
        {current && <motion.div key={current.name + current.minutes} initial={{
        opacity: 0,
        y: 30,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 30,
        scale: 0.95
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="glass-panel rounded-2xl p-4 border-brand-green/30 pointer-events-auto shadow-2xl backdrop-blur-xl" role="status" aria-live="polite" data-id="element-225">
            <div className="flex items-start gap-3" data-id="element-226">
              <div className="w-10 h-10 rounded-full bg-brand-green/10 border border-brand-green/30 flex items-center justify-center shrink-0" data-id="element-227">
                <CheckCircle2 className="w-5 h-5 text-brand-green" data-id="element-228" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-229">
                <div className="text-xs font-mono uppercase tracking-wider text-brand-green mb-1" data-id="element-230">
                  Nuevo acceso
                </div>
                <p className="text-sm text-white font-medium truncate" data-id="element-231">
                  <span className="font-bold" data-id="element-232">{current.name}</span> obtuvo
                  VISIONGOL
                </p>
                <div className="flex items-center gap-1.5 mt-1 text-xs text-gray-400" data-id="element-233">
                  <MapPin className="w-3 h-3" data-id="element-234" />
                  <span className="truncate" data-id="element-235">{current.location}</span>
                  <span className="text-gray-600" data-id="element-236">·</span>
                  <span className="text-gray-500" data-id="element-237">
                    hace {current.minutes} min
                  </span>
                </div>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}